// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__19RON","header":"ReportDetails_header__29j9R","title":"ReportDetails_title__2opLG","left":"ReportDetails_left__3USRX"};